import { dismissNotification } from '../../../features/notifications/notifications.slice';
import { store } from '../../../stores/redux';

export enum NotificationId {
  WaitingForResponse = 'fileTransferWaitForResponse',
  Uploading = 'fileTransferUploading',
  WaitForDownload = 'fileTransferWaitForDownload',
  UserIsDownloading = 'fileTransferUserIsDownloading',
}

export const dismissAllNotifications = async (): Promise<void> => {
  await Promise.all(
    Object.values(NotificationId).map(async (id) =>
      store.dispatch(dismissNotification({ id })),
    ),
  );
};
